import { render, staticRenderFns } from "./RestPassword.vue?vue&type=template&id=1e0efb7e&scoped=true&"
import script from "./RestPassword.vue?vue&type=script&lang=ts&"
export * from "./RestPassword.vue?vue&type=script&lang=ts&"
import style0 from "./RestPassword.vue?vue&type=style&index=0&id=1e0efb7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0efb7e",
  null
  
)

export default component.exports